'use strict';

let BaseService=require('../../../dist-es6/client/angularCommon/baseService');let

RecursionService=class RecursionService extends BaseService{
static get $inject(){return['$compile']}

constructor($compile){
super();








this.compile=function(element,link){

if(angular.isFunction(link)){
link={post:link};
}


var contents=element.contents().remove();
var compiledContents;

return{
pre:link&&link.pre?link.pre:null,
post:function(scope,element){

if(!compiledContents){
compiledContents=$compile(contents);
}

const childScope=scope.$new();
scope.$on('$destroy',()=>{
if(!childScope){
return;
}
childScope.$destroy();
});

compiledContents(childScope,clone=>element.append(clone));


if(link&&link.post){
link.post.apply(null,arguments);
}
}};

};
}};


module.exports=RecursionService;
//# sourceMappingURL=recursionService.js.map
